import { Helmet } from "react-helmet-async";

export default function StructuredData() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Mosheli Creative Solutions",
    "url": "https://mosheli.com",
    "logo": "https://mosheli.com/assets/logo-full.webp",
    "description": "Custom websites, mobile apps, and AI-powered marketing tools built specifically for small businesses.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "US"
    },
    "sameAs": [
      "https://twitter.com/mosheli",
      "https://linkedin.com/company/mosheli",
      "https://github.com/mosheli-sudo"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "availableLanguage": "English"
    }
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Mosheli Creative Solutions",
    "image": "https://mosheli.com/assets/logo-full.webp",
    "url": "https://mosheli.com",
    "telephone": "",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "17:00"
    }
  };

  const servicesSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "Service",
        "name": "Custom Website Development",
        "description": "Custom-built websites that convert visitors into customers. Fast, responsive, and tailored to your brand.",
        "provider": {
          "@type": "Organization",
          "name": "Mosheli Creative Solutions"
        },
        "areaServed": "US",
        "serviceType": "Web Development"
      },
      {
        "@type": "Service",
        "name": "Mobile App Development",
        "description": "Native iOS and Android applications that deliver seamless experiences on any device.",
        "provider": {
          "@type": "Organization",
          "name": "Mosheli Creative Solutions"
        },
        "areaServed": "US",
        "serviceType": "Mobile Development"
      },
      {
        "@type": "Service",
        "name": "AI Tools & Solutions",
        "description": "Custom AI-powered tools including chatbots, automation, and intelligent business solutions.",
        "provider": {
          "@type": "Organization",
          "name": "Mosheli Creative Solutions"
        },
        "areaServed": "US",
        "serviceType": "AI Development"
      },
      {
        "@type": "Service",
        "name": "Marketing Automation",
        "description": "Intelligent tools that automate your marketing, nurture leads, and drive growth on autopilot.",
        "provider": {
          "@type": "Organization",
          "name": "Mosheli Creative Solutions"
        },
        "areaServed": "US",
        "serviceType": "Marketing Automation"
      },
      {
        "@type": "Service",
        "name": "Business Analytics",
        "description": "Data-driven insights and analytics solutions to help you make better business decisions.",
        "provider": {
          "@type": "Organization",
          "name": "Mosheli Creative Solutions"
        },
        "areaServed": "US",
        "serviceType": "Business Analytics"
      },
      {
        "@type": "Service",
        "name": "Custom Software Solutions",
        "description": "Bespoke software solutions designed specifically for your unique business challenges.",
        "provider": {
          "@type": "Organization",
          "name": "Mosheli Creative Solutions"
        },
        "areaServed": "US",
        "serviceType": "Software Development"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(servicesSchema)}
      </script>
    </Helmet>
  );
}
